import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";




function Testimonial() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      <section className="home-testimonial bg-light-grey">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Section */}
            <div className="col-md-5 col-lg-5">
              <div className="section-head">
                <div className="title-divider" />
                <h2 className="section-title" data-aos="fade-right">
                  Our Customer <span className="primary-color">Feedback</span>
                </h2>
                <p>
                  We value our clients’ trust and are proud to deliver solutions
                  that drive real growth. Here’s what our customers have to say
                  about working with us.
                </p>
              </div>

              {/* Progress Stats */}
              <div className="circle-progressbar-wrap d-flex flex-wrap">
                <div className="circle-progressbar" data-animate="false">
                  <div className="circle-bar" data-percent={90}>
                    <div className="circle-number" />
                    <span>POSITIVE REVIEWS</span>
                  </div>
                </div>
                <div className="circle-progressbar" data-animate="false">
                  <div className="circle-bar" data-percent={97}>
                    <div className="circle-number" />
                    <span>SATISFIED CLIENTS</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Section - Testimonials */}
            <div className="col-md-7 col-lg-7">
              <div className="testimonial-inner">
                <div className="testimonial-item d-flex flex-wrap align-items-center" data-aos="fade-left" data-aos-delay="200">
                  <figure className="testimonial-img">
                    <img src="assets/images/img16.jpg" alt="Client feedback" />
                  </figure>
                  <div className="testimonial-content">
                    <p>
                      "Codenix Infotech transformed our digital presence. Their
                      team is professional, responsive, and truly understands
                      business needs."
                    </p>
                  </div>
                </div>

                <div className="testimonial-item d-flex flex-wrap align-items-center" data-aos="fade-left" data-aos-delay="300">
                  <figure className="testimonial-img">
                    <img src="assets/images/img17.jpg" alt="Happy customer" />
                  </figure>
                  <div className="testimonial-content">
                    <p>
                      "We’ve seen remarkable efficiency improvements since partnering
                      with them. Their innovative solutions exceeded our expectations."
                    </p>
                  </div>
                </div>

                <div className="testimonial-item d-flex flex-wrap align-items-center" data-aos="fade-left" data-aos-delay="400">
                  <figure className="testimonial-img">
                    <img src="assets/images/img18.jpg" alt="Client testimonial" />
                  </figure>
                  <div className="testimonial-content">
                    <p>
                      "Outstanding support and delivery! Codenix Infotech has
                      been a reliable tech partner in every step of our journey."
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  )
}

export default Testimonial
